export var CLUSTER;

(function (CLUSTER) {
  CLUSTER["CHAT"] = "chat";
  CLUSTER["PUSH"] = "push";
})(CLUSTER || (CLUSTER = {}));